import styled, { css } from 'styled-components';

import { Theme } from 'components/library';

import { color } from 'theme/selectors';
import { HTMLAttributes } from 'react';

export const TabButton = styled.button<{ $isActive: boolean } & HTMLAttributes<HTMLButtonElement>>`
    padding: 12px 18px;
    position: relative;
    outline: none;
    background-color: transparent;
    border: none;
    cursor: pointer;

    &:hover {
        > * {
            color: ${color('text-main')};
        }

        &:after {
            width: 80%;
        }
    }


    &:after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 0;
        height: 2px;
        transition: 0.3s;
        width: ${({ $isActive }) => ($isActive ? '80%' : 0)};
        background: ${color('primary-active')};
    }
}
`;
